import { render } from "./AppCasesFlex.vue?vue&type=template&id=70936808&scoped=true"
import script from "./AppCasesFlex.vue?vue&type=script&lang=js"
export * from "./AppCasesFlex.vue?vue&type=script&lang=js"

import "./AppCasesFlex.vue?vue&type=style&index=0&id=70936808&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70936808"]])

export default __exports__